'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactI18next = require('react-i18next');

var _reactRedux = require('react-redux');

var _reduxConnect = require('redux-connect');

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _account = require('redux/modules/account');

var accountActions = _interopRequireWildcard(_account);

var _components = require('components');

var _containers = require('containers');

var _toastr = require('helpers/toastr');

var _toastr2 = _interopRequireDefault(_toastr);

var _permissions = require('helpers/permissions');

var _auth = require('selectors/auth');

var _asyncPromise = require('helpers/async-promise');

var _asyncPromise2 = _interopRequireDefault(_asyncPromise);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _AccountName = require('containers/Account/AccountName/AccountName');

var _AccountName2 = _interopRequireDefault(_AccountName);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./Account.scss');
var dropboxImg = require('assets/dropbox-icon.png');
var boxcomImg = require('assets/boxcom-icon.png');

var Account = (_dec = (0, _reduxConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;

    var promises = [];
    promises.push(dispatch(accountActions.loadAccount()).promise);
    promises.push(dispatch(accountActions.loadUserEmails()).promise);
    return (0, _asyncPromise2.default)(_promise2.default.all(promises));
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    account: state.account.accountData,
    accountLoading: state.account.accountLoading,
    deleteEmailActionData: state.account.deleteEmailActionData,
    deleteEmailLoading: state.account.deleteEmailLoading,
    user: (0, _auth.getUser)(state),
    userEmails: state.account.userEmailsData,
    userEmailsLoading: state.account.userEmailsLoading
  };
}, (0, _extends3.default)({}, accountActions)), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(Account, _Component);

  function Account() {
    (0, _classCallCheck3.default)(this, Account);
    return (0, _possibleConstructorReturn3.default)(this, (Account.__proto__ || (0, _getPrototypeOf2.default)(Account)).apply(this, arguments));
  }

  (0, _createClass3.default)(Account, [{
    key: 'getEmailManagementElement',
    value: function getEmailManagementElement(emails) {
      var _this2 = this;

      if (!emails) {
        return false;
      }

      var _props = this.props,
          t = _props.t,
          deleteEmailLoading = _props.deleteEmailLoading,
          deleteEmailActionData = _props.deleteEmailActionData;

      var ret = [];

      emails.map(function (email) {
        ret.push(_react2.default.createElement(
          _components.ListItem,
          { fullWidth: true, key: email.email },
          _react2.default.createElement(
            'div',
            { className: styles.emailAddress },
            email.email
          ),
          _react2.default.createElement(
            'div',
            { className: styles.emailType },
            email.isPrimary ? t('Primary') : t('Secondary')
          ),
          _react2.default.createElement(
            'div',
            { className: (0, _bind2.default)(styles.emailStatus, 'colorInfo') },
            t('Verified')
          ),
          _react2.default.createElement(
            'div',
            { className: 'moreCell' },
            _react2.default.createElement('i', { className: 'more', onClick: function onClick(e) {
                return _this2.accountEmailsPopover.toggle(e, email);
              } }),
            deleteEmailLoading && deleteEmailActionData.email === email.email && _react2.default.createElement(_components.Loader, { small: true, mask: true })
          )
        ));
      });
      return ret;
    }
  }, {
    key: 'deleteEmail',
    value: function deleteEmail(email) {
      var _props2 = this.props,
          deleteEmail = _props2.deleteEmail,
          t = _props2.t;

      var toastrConfirmOptions = {
        onOk: function onOk() {
          return deleteEmail(email.email);
        },
        onCancel: function onCancel() {}
      };
      _toastr2.default.confirm(t('Are you sure you want to delete this email address?'), toastrConfirmOptions);
    }
  }, {
    key: 'makeEmailPrimary',
    value: function makeEmailPrimary(email) {
      this.props.makeEmailPrimary(email.email);
    }
  }, {
    key: 'openForgotPasswordForm',
    value: function openForgotPasswordForm() {
      this.forgotPasswordDialog.getWrappedInstance().getWrappedInstance().open();
    }
  }, {
    key: 'bindPopover',
    value: function bindPopover(el) {
      this.accountEmailsPopover = el;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props3 = this.props,
          t = _props3.t,
          account = _props3.account,
          accountLoading = _props3.accountLoading,
          userEmails = _props3.userEmails,
          userEmailsLoading = _props3.userEmailsLoading,
          user = _props3.user;


      return _react2.default.createElement(
        'div',
        { className: 'page' },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Account' }),
        _react2.default.createElement(
          'div',
          { className: 'container-fluid' },
          _react2.default.createElement(
            'h1',
            null,
            t('Account')
          ),
          _react2.default.createElement(
            'div',
            { className: 'hint' },
            t('Manage personal information')
          ),
          _react2.default.createElement(
            'section',
            { className: styles.section },
            _react2.default.createElement(
              'h3',
              null,
              t('Personal information')
            ),
            accountLoading && _react2.default.createElement(_components.Loader, null),
            account && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { className: styles.personalInfoGroupItem },
                _react2.default.createElement(
                  'span',
                  null,
                  t('Email')
                ),
                _react2.default.createElement(
                  'span',
                  null,
                  account.userEmail
                )
              ),
              _react2.default.createElement(
                'div',
                { className: styles.personalInfoGroupItem },
                _react2.default.createElement(
                  'span',
                  null,
                  t('First name')
                ),
                _react2.default.createElement(
                  'span',
                  null,
                  _react2.default.createElement(_AccountName2.default, {
                    className: styles.nameField,
                    fieldName: 'firstName'
                  })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: styles.personalInfoGroupItem },
                _react2.default.createElement(
                  'span',
                  null,
                  t('Last name')
                ),
                _react2.default.createElement(
                  'span',
                  null,
                  _react2.default.createElement(_AccountName2.default, {
                    className: styles.nameField,
                    fieldName: 'lastName'
                  })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: styles.personalInfoGroupItem },
                _react2.default.createElement(
                  'span',
                  null,
                  t('Contributor level')
                ),
                _react2.default.createElement(
                  'span',
                  null,
                  account.contributor_level
                )
              )
            )
          ),
          (0, _permissions.hasCloudServicesAccess)(user) && _react2.default.createElement(
            'section',
            { className: styles.section },
            _react2.default.createElement(
              'h3',
              null,
              t('Cloud services integration')
            ),
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'col-xs-20 col-md-15 col-lg-10' },
                _react2.default.createElement('img', { src: dropboxImg, alt: '' }),
                ' ',
                t('Dropbox')
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-xs-40 col-md-45 col-lg-50' },
                _react2.default.createElement(_components.DropboxConnectButton, null)
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row margin-top-10' },
              _react2.default.createElement(
                'div',
                { className: 'col-xs-20 col-md-15 col-lg-10' },
                _react2.default.createElement('img', { src: boxcomImg, alt: '' }),
                ' ',
                t('Box.com')
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-xs-40 col-md-45 col-lg-50' },
                _react2.default.createElement(_components.BoxcomConnectButton, null)
              )
            )
          ),
          _react2.default.createElement(
            'section',
            { className: styles.section },
            _react2.default.createElement(
              'h3',
              null,
              t('Multiple emails management')
            ),
            _react2.default.createElement(
              'div',
              { className: 'hint small' },
              t('You can have several emails address on Cright so that different people can send you content on different emails. Just define you primary email and you will receive ALL information (new content received, information from us) on the same unique email.')
            ),
            _react2.default.createElement(
              _components.List,
              null,
              _react2.default.createElement(
                _components.ListItem,
                { fullWidth: true, isTitle: true },
                _react2.default.createElement(
                  'div',
                  null,
                  t('Email')
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  t('Type')
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  t('Status')
                ),
                _react2.default.createElement('div', null)
              ),
              this.getEmailManagementElement(userEmails)
            ),
            userEmailsLoading && _react2.default.createElement(_components.Loader, null),
            _react2.default.createElement(
              _components.PopoverMenu,
              { id: 'accountEmailsPopover', ref: this.bindPopover },
              _react2.default.createElement(
                'li',
                { onClick: function onClick() {
                    return _this3.makeEmailPrimary(_this3.accountEmailsPopover.data);
                  } },
                t('Make primary'),
                ' ',
                _react2.default.createElement('i', { className: 'icon-check' })
              ),
              _react2.default.createElement(
                'li',
                { onClick: function onClick() {
                    return _this3.deleteEmail(_this3.accountEmailsPopover.data);
                  } },
                t('Delete'),
                ' ',
                _react2.default.createElement('i', { className: 'icon-delete' })
              )
            ),
            _react2.default.createElement(_components.AccountEmailForm, null)
          ),
          _react2.default.createElement(
            'div',
            { className: 'text-right margin-top-20' },
            _react2.default.createElement(
              'button',
              { type: 'button', className: 'btn btn-primary', onClick: function onClick() {
                  return _this3.openForgotPasswordForm();
                } },
              t('Change password')
            )
          ),
          _react2.default.createElement(_containers.ForgotPasswordDialog, { ref: function ref(el) {
              return _this3.forgotPasswordDialog = el;
            } })
        )
      );
    }
  }]);
  return Account;
}(_react.Component), _class3.propTypes = {
  account: _propTypes2.default.object,
  accountLoading: _propTypes2.default.bool,
  deleteEmail: _propTypes2.default.func,
  deleteEmailActionData: _propTypes2.default.object,
  deleteEmailLoading: _propTypes2.default.bool,
  makeEmailPrimary: _propTypes2.default.func,
  t: _propTypes2.default.func,
  user: _propTypes2.default.object,
  userEmails: _propTypes2.default.array,
  userEmailsLoading: _propTypes2.default.bool
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'bindPopover', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'bindPopover'), _class2.prototype)), _class2)) || _class) || _class) || _class);
exports.default = Account;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Account/Account.js
// module id = 2140
// module chunks = 1